import { Link } from "react-router-dom";
import { ArrowRight, UserRound } from "lucide-react";
import { MobileNavMenu } from "../MobileNavMenu";
import { useAuth } from "../../contexts/AuthContext";

const NAV_ITEMS = [
  ["Home", "/", "nav-home"],
  ["Free Vault", "/library-preview", "nav-free-vault"],
  ["Stag Vault Complete — £25", "/pricing", "nav-full-vault"],
  ["Shop £5 Products", "/store", "nav-shop"],
  ["Earn With Stag Vault", "/affiliates", "nav-earn"],
];
const CTA = "hidden min-h-11 items-center gap-2 border px-4 text-xs font-black uppercase tracking-[0.14em] transition-[background-color,transform] duration-200 hover:-translate-y-0.5 sm:inline-flex";

export const LandingHeader = ({ lifetimeHref, soldOut }) => {
  const { user } = useAuth();
  const lifetime = user?.tier === "lifetime";
  const vaultHref = user?.byov_size && !lifetime ? "/my-vault" : "/vault";
  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-[#030206]/90 backdrop-blur-xl" data-testid="landing-header" data-auth-state={user ? "signed-in" : "signed-out"}>
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 md:px-10">
        <Link to="/" className="flex min-w-0 items-center" data-testid="landing-home-link">
          <img src="/stag-vault-lockup-v2.webp" alt="Stag Vault" width="701" height="200" className="h-12 w-auto select-none sm:h-14 drop-shadow-[0_0_14px_rgba(168,85,247,0.35)]" decoding="async" fetchPriority="high" draggable={false} data-testid="landing-lockup" />
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Primary navigation">
          {NAV_ITEMS.map(([label, to, testId]) => (
            <Link key={to} to={to} className="inline-flex min-h-11 items-center gap-2 px-3 text-sm text-zinc-300 transition-colors hover:text-white" data-testid={testId}>
              {label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          {user ? (
            <>
              <Link to="/vault" className="hidden min-h-11 max-w-[240px] items-center gap-1.5 truncate px-3 text-sm text-zinc-300 transition-colors hover:text-white md:inline-flex" title={user.email} data-testid="nav-signed-in-as">
                <UserRound size={14} aria-hidden="true" /> <span className="truncate">{user.email}</span>
              </Link>
              <Link to={vaultHref} className={`${CTA} border-purple-400 bg-purple-500 text-black hover:bg-purple-400`} data-testid="nav-open-vault">
                {lifetime ? "Open the Vault" : user.byov_size ? "My Vault" : "Open the Vault"} <ArrowRight size={14} aria-hidden="true" />
              </Link>
            </>
          ) : (
            <>
              <Link to="/sign-in" className="hidden min-h-11 items-center px-3 text-sm text-zinc-300 transition-colors hover:text-white sm:inline-flex" data-testid="nav-sign-in">Sign In</Link>
              <Link to={soldOut ? "/pricing" : lifetimeHref} className={`${CTA} border-amber-300 bg-amber-300 text-black hover:bg-amber-200`} data-testid="nav-get-access">
                {soldOut ? "View plans" : "Unlock £25"} <ArrowRight size={14} aria-hidden="true" />
              </Link>
            </>
          )}

          <MobileNavMenu user={user} visibility="lg:hidden" testPrefix="landing-mobile" cta={user ? { to: vaultHref, label: "Open the Vault" } : { to: soldOut ? "/pricing" : lifetimeHref, label: soldOut ? "View access options" : "Unlock Stag Vault Complete · £25" }} />
        </div>
      </div>
    </header>
  );
};
